var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"title":"Not Found","icon":"mdi-alert"}},[_c('div',[_vm._v("Sorry, we couldn't find what you were looking for.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }